import Experience from "../Experience.js";
import Environment from "./Environment.js";
import Floor from "./Floor.js";
import Model from "./model.js";
import gsap from "gsap";

export default class World {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;

        this.model = null;
        this.environment = null;
        this.floor = null;

        // contiendra TOUT ce que le modèle courant a ajouté dans la scène
        this._addedNodes = [];

        // Initialisation des événements UI
        this.bindUI();
    }

    bindUI() {
        this.zoneButton = document.getElementsByClassName("zones");
        this.startExperience = document.querySelector(".startExperience");
        this.navZones = document.getElementsByClassName("navZone");

        // appliquer la classe active à la zone courante



        // Démarrage de l'expérience (bouton Start)
        this.startExperience?.addEventListener("click", async () => {
            try {
                // masquage de la page d'accueil
                gsap.to(".homePage", { opacity: 0, display: "none", delay: 0 });
                this.startExperience.innerHTML = "LOADING ...";
                this.startExperience.classList.add("loading");

                // déterminer la zone sélectionnée (0: urbain, 1: peri, 2: rural)
                const key = this.keyFromIndex(Number(this.experience.current) || 0);

                // Charger les ressources communes : HDR, indicator et flecheModel
                await this.resources.loadResource("hdrMap");
                await this.resources.loadResource("indicator");
                await this.resources.loadResource("flecheModel");

                // Charger les ressources propres à la zone
                await this.resources.loadZone(key);

                // Construire le sol et l'environnement (une seule fois)
                this.buildOnce();

                // Monter le modèle pour la zone sélectionnée
                await this.mountModel(key);
                this.model.validModel();
                gsap.to(".navbar", {
                    translateX: 0 + "%",
                    ease: "back.out(1.7)",
                    duration: 0.7,
                    delay: 3

                })
                // mise à jour du texte du bouton
                this.startExperience.innerHTML = "STARTED";
                this.navZones[this.experience.current].classList.add("active");

            } catch (e) {
                console.error(e);
                this.startExperience.innerHTML = "ERROR";
            }
        });

        // Sélection d'une zone via les cartes de la page d'accueil
        for (let i = 0; i < this.zoneButton.length; i++) {
            this.zoneButton[i].addEventListener("click", () => {
                const el = document.querySelector(`#zones${i}`);
                if (!el) return;
                this.experience.current = el.dataset.select;
                // mettre à jour la sélection
                for (let j = 0; j < this.zoneButton.length; j++) {
                    this.zoneButton[j].classList.remove("select");
                }
                this.zoneButton[i].classList.add("select");
                gsap.to(this.zoneButton[i], {
                    scale: 1.05,
                    duration: 0.1,
                    onComplete: () => gsap.to(this.zoneButton[i], { scale: 1, duration: 0.1 }),
                });
            });
        }

        // Navigation entre les zones (barre de menu)
        for (let i = 0; i < this.navZones.length; i++) {
            this.navZones[i].addEventListener("click", async () => {
                const key = this.keyFromIndex(i);

                this.experience.current = `${i}`;

                // si l'expérience n'est pas encore démarrée, on ne fait rien

                if (!this.floor || !this.environment) return;
                // mise à jour de l'onglet actif

                for (let j = 0; j < this.navZones.length; j++) {
                    this.navZones[j].classList.remove("active");
                }

                this.navZones[i].classList.add("active");

                // if (  this.resources.items[key]) {


                if (!this.resources.items.urbainModel && key === "urbain") {
                    this.model.showLoader()
                    // console.log(this.resources.items.urbainModel);
                    await this.resources.loadZone(key);
                    await this.validUrbain()



                }
                else if (!this.resources.items.periModel && key === "peri") {
                                        this.model.showLoader()
                    // console.log(this.resources.items.periModel);
                    await this.resources.loadZone(key);

                    await this.validPeri()
                }
                else if (!this.resources.items.ruralModel && key === "rural") {
                                        this.model.showLoader()
                    // console.log(this.resources.items.ruralModel);
                    await this.resources.loadZone(key);
                    await this.validRural()
                  
                }

else {
    this.model.validModel();
}

                // }

                // charger les ressources spécifiques à la zone
                // await this.resources.loadZone(key);
                // this.model.validModel();
            });
        }
    }

    keyFromIndex(i) {
        return i === 0 ? "urbain" : i === 1 ? "peri" : "rural";
    }

    buildOnce() {
        if (!this.floor) this.floor = new Floor();
        if (!this.environment) this.environment = new Environment();
    }

    _getResourceScenes() {
        const roots = new Set();
        const items = this.resources?.items || {};
        for (const k in items) {
            const it = items[k];
            if (it && it.scene && (it.scene.isObject3D || it.scene.isScene)) {
                roots.add(it.scene);
            }
        }
        return roots;
    }
 validPeri() {
    //   console.log(this.resources.items);

  this.crossButton = document.getElementsByClassName("cross")

            this.actionButton = document.getElementsByClassName("action_button")
     
        // anim de la navbar et nettoyage
        gsap.to(".navbar", {
            translateX: "0%",
            ease: "back.out(1.7)",
            duration: 0.7,
            delay: 3
        })
        
        this.model.cls()

        // réinitialisation du menu et des boutons
        this.menuClick = { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false }
        for (let i = 0; i < 5; i++) {
            this.actionButton[i].style.background = "#1A2783"
            this.actionButton[i].style.color = "#fff"
            this.menuClick[i] = false
            gsap.to(this.crossButton[i], { rotate: 0, ease: "back.out(1.7)", color: "#fff" })
        }
              this.model.setTransition()
        // désactive les interactions le temps des transitions
        this.model.canvas.style.pointerEvents = "none"
          



            this.model.transitionModelOn()

            this.model.clsModelRural()

            this.model.clsModelPeri()
            this.model.clsModelUrb()
            // zone péri‑urbaine






            this.model.setPeriModel()

            this.model.setVehiculePeri()
            this.model.animFLuxPeri()
                        this.model.animFluxUrbain()


            this.model.setAnimationVehicule()


            this.model.setGroupPeriUrbain()


            this.model.scene.add(this.model.periModel, this.model.batiUrbain, this.model.vehiculeModel)

            gsap.to(this.model.controls.target, {
                x: -38.19536,
                y: -57.923423,
                z: 14.36664,
                ease: "Power4.easeInOut",
                duration: 3
            })
            gsap.to(this.model.camera.instance.position, {
                x: -373.40963,
                y: 195.45384,
                z: 217.86126,
                ease: "Power4.easeInOut",
                duration: 3,
                onComplete: () => {
                    this.model.canvas.style.pointerEvents = "auto"
                    this.model.transitionModelOff()
                }
            })
            this.model.hideLoader();
            this.model.setRaycast()

    }



    validUrbain() {
            // console.log(this.resources.items);

  this.crossButton = document.getElementsByClassName("cross")

            this.actionButton = document.getElementsByClassName("action_button")
     
        // anim de la navbar et nettoyage
        gsap.to(".navbar", {
            translateX: "0%",
            ease: "back.out(1.7)",
            duration: 0.7,
            delay: 3
        })
        
        this.model.cls()

        // réinitialisation du menu et des boutons
        this.menuClick = { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false }
        for (let i = 0; i < 5; i++) {
            this.actionButton[i].style.background = "#1A2783"
            this.actionButton[i].style.color = "#fff"
            this.menuClick[i] = false
            gsap.to(this.crossButton[i], { rotate: 0, ease: "back.out(1.7)", color: "#fff" })
        }
              this.model.setTransition()
        // désactive les interactions le temps des transitions
        this.model.canvas.style.pointerEvents = "none"
          



            this.model.transitionModelOn()
            // masque les autres maquettes
            this.model.clsModelRural()
            this.model.clsModelPeri()
            this.model.clsModelUrb()
        
            
              this.model.setUrbainModel()

            this.model.setVehicule()

            this.model.animFluxUrbain()

            this.model.setAnimationVehiculeUrbain()
            this.model.setGroupUrbain()
      
            // ajoute les éléments à la scène (ajustez selon vos variables)
            this.model.scene.add(this.model.urbainModel, this.model.batiPeri, this.model.vehiculeUrbainModel)

            // navigation : retire les classes "active"
          

            // anime la caméra et la cible
            gsap.to(this.model.controls.target, {
                x: -38.8233,
                y: -6.6831,
                z: 19.7368,
                ease: "Power4.easeInOut",
                duration: 3
            })
            gsap.to(this.model.camera.instance.position, {
                x: -353.6932,
                y: 198.1518,
                z: 375.4336,
                ease: "Power4.easeInOut",
                duration: 3,
                onComplete: () => {
                    this.model.canvas.style.pointerEvents = "auto"
                    this.model.transitionModelOff()
                }
            })
            this.model.hideLoader();
            this.model.setRaycast()


    }
validRural() {
        // console.log(this.resources.items);

  this.crossButton = document.getElementsByClassName("cross")

            this.actionButton = document.getElementsByClassName("action_button")

        // anim de la navbar et nettoyage
        gsap.to(".navbar", {
            translateX: "0%",
            ease: "back.out(1.7)",
            duration: 0.7,
            delay: 3
        })
        this.model.cls()

        // réinitialisation du menu et des boutons
        this.menuClick = { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false }
        for (let i = 0; i < 5; i++) {
            this.actionButton[i].style.background = "#1A2783"
            this.actionButton[i].style.color = "#fff"
            this.menuClick[i] = false
            gsap.to(this.crossButton[i], { rotate: 0, ease: "back.out(1.7)", color: "#fff" })
        }
              this.model.setTransition()

        // désactive les interactions le temps des transitions
        this.model.canvas.style.pointerEvents = "none"


      this.model.transitionModelOn()
            // masque les autres maquettes
            this.model.clsModelRural()
            this.model.clsModelPeri()
            this.model.clsModelUrb()
  

            this.model.setRuralModel()

            this.model.setVehiculeRural()
            this.model.animFluxRural()
                                    this.model.animFluxUrbain()

            this.model.setAnimationVehiculeRural()
            // this.setFlecheModel()
            this.model.setGroupRural()
            this.model.setAnimationEolienne()
            
            // zone rurale
          

            this.model.scene.add(this.model.ruralModel, this.model.batiRural, this.model.vehiculeRuralModel, this.model.eolienneModel)

         

            gsap.to(this.model.controls.target, {
                x: -200.1672,
                y: 7.6308,
                z: -236.9340,
                ease: "Power4.easeInOut",
                duration: 3
            })
            gsap.to(this.model.camera.instance.position, {
                x: -687.4602,
                y: 210.49697,
                z: 492.03155,
                ease: "Power4.easeInOut",
                duration: 3,
                onComplete: () => {
                    this.model.canvas.style.pointerEvents = "auto"
                    this.model.transitionModelOff()
                }
            })
            this.model.hideLoader();
            this.model.setRaycast()
   
}
    _purgePreviousModel() {
        if (!this._addedNodes || !this._addedNodes.length) return;
        const resourceRoots = this._getResourceScenes();
        const isFromResource = (node) => {
            let n = node;
            while (n) {
                if (resourceRoots.has(n)) return true;
                n = n.parent;
            }
            return false;
        };
        for (const obj of this._addedNodes) {
            if (!obj) continue;
            if (obj.parent) obj.parent.remove(obj);
            if (isFromResource(obj)) continue;
            obj.traverse((o) => {
                if (o.geometry) {
                    try {
                        o.geometry.dispose();
                    } catch (_) { }
                }
                if (o.material) {
                    try {
                        if (Array.isArray(o.material)) {
                            o.material.forEach((m) => m && m.dispose && m.dispose());
                        } else {
                            o.material.dispose && o.material.dispose();
                        }
                    } catch (_) { }
                }
            });
        }
        this._addedNodes = [];
    }

    _toggleOtherZonesVisibility(activeKey) {
        const items = this.resources?.items || {};
        const isScene = (x) => x && (x.isScene || x.isObject3D);
        const zones = {
            urbain: ["urbainModel", "vehiculeUrbain", "fluxUrbain"],
            peri: ["periModel", "vehiculeModel", "vehiculeModelPeri"],
            rural: ["ruralModel", "vehiculeRural", "fluxRural", "eoliennes"],
        };
        const allKeys = ["urbain", "peri", "rural"];
        for (const z of allKeys) {
            const list = zones[z] || [];
            const visible = z === activeKey;
            for (const name of list) {
                const asset = items[name];
                if (asset && isScene(asset.scene)) {
                    asset.scene.visible = visible;
                }
            }
        }
    }

    async mountModel(key) {
        // supprimer l'ancien modèle
        const before = new Set(this.scene.children);
        const previousModel = this.model;
        this.model = new Model({ group: key });
        // charger et monter la maquette selon la zone
        if (key === "urbain") {
            await this.model.setUrbainModel();
        } else if (key === "peri") {
            await this.model.setPeriModel();
        } else if (key === "rural") {
            await this.model.setRuralModel();
        }
        const after = new Set(this.scene.children);
        this._addedNodes = [...after].filter((o) => !before.has(o));
        // disposer l'ancien modèle
        previousModel?.dispose?.();
        // masquer les autres zones
        this._toggleOtherZonesVisibility(key);
    }

    update() {
        this.model?.update?.();
    }
}